import React, { useMemo, useState } from "react";
import { FaPlayCircle, FaChevronDown } from "react-icons/fa";

function extractYouTubeId(url) {
  if (!url) return "";
  try {
    const u = new URL(url);

    // https://www.youtube.com/watch?v=ID
    if (u.hostname.includes("youtube.com")) {
      return u.searchParams.get("v") || "";
    }

    // https://youtu.be/ID
    if (u.hostname.includes("youtu.be")) {
      return u.pathname.replace("/", "") || "";
    }
  } catch (e) {
    // fallback simple si URL pas standard
    const short = url.split("youtu.be/")[1];
    if (short) {
      return short.split(/[?&]/)[0];
    }
    const long = url.split("watch?v=")[1];
    if (long) {
      return long.split(/[?&]/)[0];
    }
  }
  return "";
}

const QuizzVideoCard = ({ quizz }) => {
  const [showDetails, setShowDetails] = useState(false);

  const videoId = useMemo(
    () => extractYouTubeId(quizz.lien_url_video),
    [quizz.lien_url_video]
  );

  const imageUrl = videoId
    ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
    : "/img/default_video.jpg";

  const toggleDetails = () => setShowDetails((v) => !v);

  const handleOpenVideo = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (quizz.lien_url_video) {
      window.open(quizz.lien_url_video, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <article className="group flex flex-col rounded-2xl border border-slate-200/80 dark:border-slate-700/80 bg-white/95 dark:bg-slate-900/80 shadow-sm hover:shadow-md transition overflow-hidden">
      {/* Vignette vidéo */}
      <div className="relative">
        <button
          type="button"
          onClick={handleOpenVideo}
          className="w-full h-44 sm:h-48 relative overflow-hidden"
        >
          <img
            src={imageUrl}
            alt={quizz.nom_quizz}
            className="w-full h-full object-cover transform group-hover:scale-[1.03] transition-transform duration-200"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="inline-flex items-center justify-center rounded-full bg-white/90 px-4 py-2 shadow-lg">
              <FaPlayCircle className="text-primary text-xl mr-2" />
              <span className="text-xs font-semibold text-slate-900">
                Lire la vidéo
              </span>
            </span>
          </div>
        </button>
      </div>

      {/* Corps */}
      <div className="flex-1 px-4 py-3 flex flex-col gap-3">
        <header className="flex items-start justify-between gap-2">
          <h3 className="text-sm sm:text-[15px] font-semibold leading-snug text-slate-900 dark:text-slate-50 font-montserrat line-clamp-2">
            {quizz.nom_quizz}
          </h3>
          {quizz.famille_quizz && (
            <span className="inline-flex items-center rounded-full bg-slate-100 dark:bg-slate-800 text-[0.7rem] px-2 py-1 text-slate-700 dark:text-slate-200 whitespace-nowrap ml-1">
              {quizz.famille_quizz}
            </span>
          )}
        </header>

        {/* AUCUNE explication visible ici pour ne pas donner la réponse */}

        {/* Correction repliable */}
        <div className="mt-1 border-t border-slate-200/70 dark:border-slate-700/70 pt-2">
          <button
            type="button"
            onClick={toggleDetails}
            className="w-full flex items-center justify-between text-xs sm:text-[0.8rem] font-semibold text-primary hover:text-primary/80"
          >
            <span>
              {showDetails
                ? "Masquer la correction"
                : "Afficher la correction"}
            </span>
            <FaChevronDown
              className={`ml-2 text-[0.7rem] transition-transform ${
                showDetails ? "rotate-180" : ""
              }`}
            />
          </button>

          {showDetails && (
            <div className="mt-2 space-y-1 text-xs sm:text-[0.8rem] text-slate-700 dark:text-slate-200">
              {quizz.decision && (
                <p>
                  <span className="font-semibold text-emerald-600 dark:text-emerald-400">
                    Décision :
                  </span>{" "}
                  {quizz.decision}
                </p>
              )}
              {quizz.description && (
                <p>
                  <span className="font-semibold">Explications :</span>{" "}
                  {quizz.description}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </article>
  );
};

export default QuizzVideoCard;
